/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-05-29 15:04:38
 *
 *******************************************************/
// @flow

// export const NUMBER_CUSTOM_RANGE_SLIDERS = 12;

export const TAG_OPTION_SELECT_TYPES = [
  { value: 'all', label: 'AdminHTML.CustomRangeSlider.Constants.tagOptionValues_All' },
  { value: 'specific', label: 'AdminHTML.CustomRangeSlider.Constants.tagOptionValues_Specific' }
];
